/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ares_SearchingInputs */

const cs_ares_searching = /** @type {(inputs: Ares_SearchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledám…`)
};

const en_ares_searching = /** @type {(inputs: Ares_SearchingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Searching…`)
};

/**
* | output |
* | --- |
* | "Searching…" |
*
* @param {Ares_SearchingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ares_searching = /** @type {((inputs?: Ares_SearchingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ares_SearchingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ares_searching(inputs)
	return cs_ares_searching(inputs)
});